import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e71aa26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carrierslist" }
const _hoisted_2 = { class: "flex itemscenter justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "w-100 flex items-center justify-between mt-3" }
const _hoisted_6 = { class: "flex justify-end mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_carrier_tripartite_agreemeent_modal = _resolveComponent("carrier-tripartite-agreemeent-modal")!
  const _component_carrier_send = _resolveComponent("carrier-send")!
  const _component_carrier_form = _resolveComponent("carrier-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_carriers_table_actions = _resolveComponent("carriers-table-actions")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.carrier_tripartite_agreement_state.is_opened)
      ? (_openBlock(), _createBlock(_component_carrier_tripartite_agreemeent_modal, {
          key: 0,
          "initial-value": _ctx.carrier_tripartite_agreement_state.initial_value,
          onCancel: _ctx.onCarrierTripartiteAgreementCancel,
          onSubmit: _ctx.onCarrierTripartiteAgreementCancel
        }, null, 8, ["initial-value", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.state_send.is_opened)
      ? (_openBlock(), _createBlock(_component_carrier_send, {
          key: 1,
          id: _ctx.state_send.id,
          bin: _ctx.state_send.bin,
          couriers: _ctx.state_send.couriers,
          onCancel: _ctx.onCancelSend
        }, null, 8, ["id", "bin", "couriers", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_carrier_form, {
          key: 2,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "initial-value": _ctx.actions_state.initial_value,
          loading: _ctx.actions_state.is_actions_loading,
          onCancel: _ctx.closeActions,
          onCreate: _ctx.createCarrier,
          onUpdate: _ctx.updateCarrier
        }, null, 8, ["is-create", "is-update", "initial-value", "loading", "onCancel", "onCreate", "onUpdate"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_page_title, { title: "Поставщики" }),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.havePermissions(['carrier-store', 'all-root-permission']))
                ? (_openBlock(), _createBlock(_component_the_button, {
                    key: 0,
                    class: "primary small mr-3",
                    onClick: _ctx.startCreate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Добавить поставщика ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.havePermissions(['carrier-store-via-jira', 'all-root-permission']))
                ? (_openBlock(), _createBlock(_component_the_button, {
                    key: 1,
                    class: "primary small",
                    onClick: _ctx.addCarriersJira,
                    loading: _ctx.state_jira.is_loading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Добавить поставщиков через Jira ")
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("form", {
            class: "flex flex-col px-6 py-4 border bg-white mt-6",
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.loadCarriers(1)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_the_input, {
                value: _ctx.state.search,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.search) = $event)),
                placeholder: "Поиск по названию"
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                value: _ctx.state.bin,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.bin) = $event)),
                placeholder: "Поиск по БИН",
                class: "ml-4"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_checkbox, {
                value: _ctx.state.isStandardContract,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.isStandardContract) = $event)),
                label: "Стандартный договор",
                class: "mr-3",
                "return-integer": ""
              }, null, 8, ["value"]),
              _createVNode(_component_checkbox, {
                class: "mr-3",
                value: _ctx.state.isTripartiteContract,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.isTripartiteContract) = $event)),
                label: "Трёхсторонний договор",
                "return-integer": ""
              }, null, 8, ["value"]),
              _createVNode(_component_checkbox, {
                value: _ctx.state.isSupplier,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.isSupplier) = $event)),
                label: "Поставщик",
                class: "mr-3",
                onChange: _ctx.onIsSupplier
              }, null, 8, ["value", "onChange"]),
              _createVNode(_component_checkbox, {
                value: _ctx.state.isCourierSupplier,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.isCourierSupplier) = $event)),
                label: "Поставщик курьеров",
                class: "mr-3",
                onChange: _ctx.onIsCourierSupplier
              }, null, 8, ["value", "onChange"]),
              _createVNode(_component_checkbox, {
                value: _ctx.state.isCarrier,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.isCarrier) = $event)),
                label: "Перевозчик",
                onChange: _ctx.onIsCarrier
              }, null, 8, ["value", "onChange"]),
              _createVNode(_component_checkbox, {
                value: _ctx.state.typeTons,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.typeTons) = $event)),
                "return-integer": "",
                label: "Менее 3х тонн"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_the_button, {
                class: "second text small mr-3",
                disabled: _ctx.data_state.is_loading,
                onClick: _ctx.reset
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" Сбросить ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_the_button, {
                class: "primary text small",
                loading: _ctx.data_state.is_loading,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" Поиск ")
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ], 32),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.data_state.is_failed && !_ctx.data_state.failure.error_state.is_cancel)
              ? (_openBlock(), _createBlock(_component_failed_fetch, {
                  key: 0,
                  loading: _ctx.data_state.is_loading,
                  text: "При получении списка перевозчиков произошла ошибка",
                  "error-message": _ctx.data_state.failure.error_state.message,
                  "error-url": _ctx.data_state.failure.error_state.url,
                  "error-status": _ctx.data_state.failure.error_state.status,
                  onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.pagination.current_page)))
                }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
              : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                  key: 1,
                  class: "mt-6",
                  loading: _ctx.data_state.is_loading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_table, {
                      loading: _ctx.data_state.is_loading,
                      columns: _ctx.CarriersColumns,
                      rows: _ctx.data_state.list,
                      "with-limit": "",
                      "pagination-limit": _ctx.state.limit,
                      "pagination-total-items": _ctx.data_state.pagination.total_items,
                      "pagination-current-page": _ctx.data_state.pagination.current_page,
                      "pagination-total-pages": _ctx.data_state.pagination.total_pages,
                      onChangePage: _ctx.loadCarriers,
                      onChangeLimit: _ctx.onLimitChange
                    }, {
                      buttons: _withCtx(() => [
                        _createVNode(_component_the_button, {
                          class: "primary text small mr-3",
                          onClick: _ctx.exportExcel,
                          loading: _ctx.excel_state.is_loading,
                          hint: "Скачать в Excel"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ]),
                      td: _withCtx(({ row, column }) => [
                        (column.key === 'activity')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.cutName(_ctx.getActivityString(row.activity), 12)), 1)
                            ], 64))
                          : (column.key === 'status')
                            ? (_openBlock(), _createBlock(_component_cheap, {
                                key: 1,
                                class: _normalizeClass(`small ${_ctx.CarriersStatusesEnum[row.status]}`)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.status), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            : (column.key === 'typeTons')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (row.typeTons)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode("Да")
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode("Нет")
                                      ], 64))
                                ], 64))
                              : (column.key === 'name')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 3,
                                    to: `/couriers/carriers/${row.id}`,
                                    class: "carrierslist__link"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key], 12)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (column.key === 'contract_number')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(_toDisplayString(row[column.key] || '-') + ", " + _toDisplayString(_ctx.formatDateFromBackend(row.contract_date) || '-'), 1)
                                    ], 64))
                                  : (column.key === 'created_at')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        (row.created_at)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(row.created_at.replaceAll('-', '.')), 1)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                        _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key], 12)), 1)
                                      ], 64))
                      ]),
                      actions: _withCtx(({ row }) => [
                        _createVNode(_component_carriers_table_actions, {
                          id: row.id,
                          "is-standard-contract": row.is_standard_contract,
                          "code-one-c": row.code_1c,
                          carrier: row,
                          onSend: _ctx.onSend,
                          onActivate: _ctx.activateCarrier,
                          onDeactivate: _ctx.deactivateCarrier,
                          onUpdate: ($event: any) => (_ctx.startUpdate(row)),
                          onTripartiteAgreement: ($event: any) => (_ctx.onCarrierTripartiteAgreement(row))
                        }, null, 8, ["id", "is-standard-contract", "code-one-c", "carrier", "onSend", "onActivate", "onDeactivate", "onUpdate", "onTripartiteAgreement"])
                      ]),
                      _: 1
                    }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                  ]),
                  _: 1
                }, 8, ["loading"]))
          ])
        ], 64))
  ]))
}